import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';

@Component({
  selector: 'swipe-to-buy-header-modal',
  template: `
    <img src="//media.staticontent.com/media/pictures/{{mediaKey}}"
           class="swipeToBuyImage" alt="swipe-to-buy">
  `,
  encapsulation: ViewEncapsulation.None
})
export class SwipeToBuyHeaderModal implements OnInit {
  @Input() partner: any;
  @Input() pictureMediaKey: string;

  mediaKey: string;

  ngOnInit() {
    this.mediaKey = this.pictureMediaKey || (this.partner != null ? '161a9340-2b78-4056-a3a5-221e6ec90179' : '0eb4d39b-3e20-43aa-8769-ede5745569a7');
  }
}
